<template>
	<div
		class="py-3 border-t border-border-tertiary"
	>
		<button
			class="flex items-center justify-between w-full gap-4 text-left"
			@click.prevent="toggle"
		>
			<h2
				class="typo-h2 text-heading-primary"
			>
				{{ title }}
			</h2>
			<NuxtIcon
				name="chevron-down"
				class="text-3xl text-icon-primary transition"
				:class="{'scale-y-[-1]': isOpen}"
				filled
			/>
		</button>
		<ExpandTransition :appear="true">
			<div v-show="isOpen">
				<div class="pt-2">
					<slot />
				</div>
			</div>
		</ExpandTransition>
	</div>
</template>

<script setup lang="ts">
	import {set} from '@vueuse/core';

	interface Props {
		title: string
	}

	defineProps<Props>();

	const isOpen = ref<boolean>(false);
	const toggle = () => {
		set(isOpen, !isOpen.value);
	};
</script>
